module.exports = __webpack_public_path__ + "img/portrait-earbuds-hands.7a6a186f.svg";